import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import { clipTextH5 } from '@ifeng-fe/ui_clip_text';
import HiddenSeoTime from '../../../../../common/seoUpdateTime';
import { isSeoAbSummaryBucket, isSeoAbTitleBucket } from '../../../../../common/seoAbBucket';

/**
 * 定义 VideoTitle 组件
 */
class VideoTitle extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        id: PropTypes.string,
        _id: PropTypes.string,
        userId: PropTypes.string,
        wemediaDetail: PropTypes.object,
        shareMediaIdApp: PropTypes.string,
        isVideoShare: PropTypes.bool,
        wxLaunch: PropTypes.object,
        sourceAlias: PropTypes.string,
        sourceReason: PropTypes.string,
        wemediaEAccountId: PropTypes.string,
        publishTime: PropTypes.string,
        updateTime: PropTypes.string,
    };

    titleDom = React.createRef();

    brefDom = React.createRef();

    brefTextDom = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            isShowClipBtn: true,
            isShowAllBref: false,
            summaryStateValue: '',
        };
    }

    getDisplayTitle = () => {
        const {
            content: { title, seoAbValue, seoTitle },
        } = this.props;

        return isSeoAbTitleBucket(seoAbValue) && seoTitle ? seoTitle : title;
    };

    getDisplaySummary = () => {
        const {
            content: { title, summary, cardSummary, seoAbValue, seoTitle, seoDescription },
        } = this.props;

        let summaryValue = '';

        if (isSeoAbSummaryBucket(seoAbValue) && seoDescription) {
            summaryValue = seoDescription;
        } else if (typeof window === 'object') {
            if (location.href.includes('channelId=NEWSCARD')) {
                summaryValue = cardSummary || summary || '';
            } else {
                summaryValue = summary || cardSummary || '';
            }
        }

        const normalizedSummary = String(summaryValue || '').trim();

        if (
            normalizedSummary &&
            (normalizedSummary === String(title || '').trim() || normalizedSummary === String(seoTitle || '').trim())
        ) {
            return '';
        }

        return summaryValue;
    };

    handleClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { id, _id, userId, shareMediaIdApp, isVideoShare } = this.props;
        const nodata = '';
        const doc_type = 'phvideo';
        const to_url = location.href;
        const userIdVal = userId || '';
        const others = shareMediaIdApp ? { subid: shareMediaIdApp } : {};
        const client = isVideoShare ? 'videoApp' : 'newsApp';
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
              };
        const callImmersiveVideoConfig = {
            docType: 'videoimmersionv2',
            pid: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${id}`,
        };

        if (isCallApp) {
            callApp({
                client,
                docType: doc_type,
                pid: _id || id,
                kind: 'share01',
                userId: userIdVal,
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
                ...callImmersiveVideoConfig
            });
        }
    };

    componentDidMount() {
        const summaryValue = this.getDisplaySummary();

        if (summaryValue) {
            let summaryHandle = '';
            const res = clipTextH5({
                content: summaryValue,
                line: 2,
                ellips: '...',
                addonDom: this.brefTextDom.current,
                wrapDom: this.brefDom.current,
            });

            summaryHandle = res.text;

            if (!res.overflow) {
                this.setState({
                    isShowClipBtn: false,
                });
            } else {
                summaryHandle = `${summaryHandle.slice(0, summaryHandle.length - 4)}...`;
            }

            this.setState({
                summaryStateValue: summaryHandle,
            });
        }
    }

    handleClipChange = () => {
        this.setState({
            isShowClipBtn: false,
            isShowAllBref: true,
        });
    };

    render() {
        const {
            wemediaDetail = {},
            isVideoShare,
            wxLaunch,
            id,
            _id,
            sourceAlias,
            sourceReason,
            wemediaEAccountId,
            publishTime,
            updateTime,
        } = this.props;
        const { catename, logo, originalName, description, honorImg, declare, cateSource, lastArticleAddress } =
            wemediaDetail;
        const { summaryStateValue, isShowClipBtn, isShowAllBref } = this.state;
        const callImmersiveVideoConfig = {
            docType: 'videoimmersionv2',
            pid: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${id}`,
        };
        const schemeLink =
            wxLaunch.wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: 'phvideo',
                      pid: _id || id,
                      ...callImmersiveVideoConfig
                  })
                : getSchemeLink({
                      docType: 'phvideo',
                      pid: _id || id,
                      kind: 'share01',
                      ...callImmersiveVideoConfig
                  });
        const displayTitle = this.getDisplayTitle();
        const summaryValue = this.getDisplaySummary();

        return (
            <header aria-label="视频播放信息" className={styles.titleContainer}>
                {!wemediaEAccountId && sourceAlias && sourceReason === '其他' ? (
                    <div className={styles.videoOtherCall}>
                        <div className={styles.sourceFrom} aria-label="媒体名称">{sourceAlias}</div>
                        <HiddenSeoTime showHiddenPublish publishTime={publishTime} updateTime={updateTime} />
                    </div>
                ) : (
                    <div className={styles.videoCall} onClick={this.handleClick}>
                        {logo && (
                            <div className={styles.headImg}>
                                <img src={logo} />
                                {!!honorImg && (
                                    <div
                                        className={styles.honorIcon}
                                        style={{
                                            background: `url(${honorImg})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'contain',
                                        }}
                                    />
                                )}
                            </div>
                        )}
                        <div className={styles.rightBox}>
                            <div className={styles.source}>
                                {catename && <p className={styles.sourceFrom}>{catename}</p>}
                                {cateSource ? <div className={styles.fhhTag}>大风号</div> : null}
                                {catename && (
                                    <img
                                        src="https://x0.ifengimg.com/cmpp/2020/0313/cbdf1339b773417size1_w80_h40.png"
                                        className={styles.fllowBtn}
                                    />
                                )}
                            </div>
                            <div className={styles.descInfo}>
                                {!!originalName && <div className={styles.parentname}>{originalName}</div>}
                                <p className={styles.description}>
                                    {description}&nbsp;&nbsp;{lastArticleAddress || ''}
                                    <HiddenSeoTime showHiddenPublish publishTime={publishTime} updateTime={updateTime} />
                                </p>
                            </div>
                        </div>
                        {!isVideoShare && wxLaunch.wxLaunchSwitch && (
                            <WxLaunchApp
                                launchType={wxLaunch.wxLaunchType}
                                launchAppClick={this.handleClick.bind(this, true, false, false)}
                                schemeLink={schemeLink}
                                launchAppFail={this.handleClick.bind(this, false, true, true)}
                            />
                        )}
                    </div>
                )}
                <div className={styles.titleLine}>
                    <div className={`${styles.titleInfo}`} ref={this.titleDom}>
                        <div className={styles.titleHead}>
                            <h1 className={styles.videoTitle}>{displayTitle}</h1>
                        </div>
                        {summaryValue && !isShowAllBref && (
                            <p ref={this.brefDom} className={styles.videoBref}>
                                {summaryStateValue}
                                {isShowClipBtn && (
                                    <span
                                        ref={this.brefTextDom}
                                        className={styles.videoBrefTextBtn}
                                        onClick={this.handleClipChange}>
                                        展开
                                    </span>
                                )}
                            </p>
                        )}
                        {summaryValue && isShowAllBref && <p className={styles.videoBref}>{summaryValue}</p>}
                    </div>
                    {declare ? <p className={styles.disclaimer}>{declare}</p> : null}
                </div>
            </header>
        );
    }
}

export default errorBoundary(VideoTitle);
